(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.products-carousel__slider');

      // Skip carousel initialization for Grid-style sections: their markup
      // doesn't render the prev/next controls, so Swiper would be handed
      // null navigation elements and throw on init.
      if (!swiperContainer || !swiperContainer.classList.contains('swiper')) return;

      const swiperNext = this.querySelector('.products-carousel__control-next');
      const swiperPrev = this.querySelector('.products-carousel__control-prev');

      const sizeCardSettings = {
        default: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 2.75,
              spaceBetween: 48,
            },
          },
        },
        large: {
          slidesPerView: 1.1,
          spaceBetween: 24,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
          },
        },
      };

      const mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        speed: 300,
        ...sizeCardSettings[this.cardsSize]
      };

      this.swiper = new Swiper(swiperContainer, mainSettings);
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        this.swiper.destroy(true, true);
      } else {
        this.swiper = new Swiper(swiperContainer, mainSettings);
      }
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
